export const AppPath = {
    EMPTY: '',
    ALL: '**',
    ABOUT_US: 'about-us',
    // BLOG:'blog',
    CONTACT_US: 'contact-us',
    FEATURES: 'features',
    PRICING: 'pricing',
    COOKIE_POLICY: 'cookie-policy',
    PRIVACY_POLICY: 'privacy-policy',
    TERMS_AND_CONDITIONS: 'terms-and-conditions',
} as const;
